import type { ThemeCollection } from '../types/theme.types';

// Dramatic themes with large, heavily overlapping ellipses - blur values converted to percentages
export const DRAMATIC_THEMES: ThemeCollection = {
  volcanic: {
    backgroundColor: '#1a0f0a',
    shapes: [
      {
        id: 'volcanic-1',
        width: 120,
        height: 45,
        x: -30,
        y: 10,
        gradient: 'radial-gradient(ellipse, #ff4757 0%, #ff3838 30%, #ff6348 70%, #ffa502 100%)',
        blur: 23,
        opacity: 0.8,
        zIndex: 1,
      },
      {
        id: 'volcanic-2',
        width: 110,
        height: 40,
        x: 30,
        y: 35,
        gradient: 'radial-gradient(ellipse, #ff6348 0%, #ff4757 40%, #c44569 80%, #f8b500 100%)',
        blur: 21,
        opacity: 0.7,
        zIndex: 2,
      },
      {
        id: 'volcanic-3',
        width: 100,
        height: 35,
        x: -10,
        y: 60,
        gradient: 'radial-gradient(ellipse, #ffa502 0%, #ff6348 50%, #ff4757 100%)',
        blur: 20,
        opacity: 0.9,
        zIndex: 3,
      },
      {
        id: 'volcanic-4',
        width: 95,
        height: 30,
        x: 50,
        y: -5,
        gradient: 'radial-gradient(ellipse, #c44569 0%, #ff3838 60%, #ffa502 100%)',
        blur: 19,
        opacity: 0.6,
        zIndex: 4,
      },
    ],
  },
  electric: {
    backgroundColor: '#0a0a23',
    shapes: [
      {
        id: 'electric-1',
        width: 130,
        height: 50,
        x: -25,
        y: 15,
        gradient: 'radial-gradient(ellipse, #00f5ff 0%, #0078ff 40%, #7d5fff 80%, #ff006e 100%)',
        blur: 24,
        opacity: 0.8,
        zIndex: 1,
      },
      {
        id: 'electric-2',
        width: 115,
        height: 45,
        x: 25,
        y: 40,
        gradient: 'radial-gradient(ellipse, #7d5fff 0%, #00f5ff 30%, #ff006e 70%, #0078ff 100%)',
        blur: 23,
        opacity: 0.7,
        zIndex: 2,
      },
      {
        id: 'electric-3',
        width: 105,
        height: 40,
        x: -15,
        y: 65,
        gradient: 'radial-gradient(ellipse, #ff006e 0%, #7d5fff 50%, #00f5ff 100%)',
        blur: 21,
        opacity: 0.9,
        zIndex: 3,
      },
      {
        id: 'electric-4',
        width: 120,
        height: 35,
        x: 60,
        y: -10,
        gradient: 'radial-gradient(ellipse, #0078ff 0%, #ff006e 40%, #00f5ff 80%, #7d5fff 100%)',
        blur: 20,
        opacity: 0.6,
        zIndex: 4,
      },
      {
        id: 'electric-5',
        width: 85,
        height: 25,
        x: 40,
        y: 80,
        gradient: 'radial-gradient(ellipse, #00f5ff 0%, #7d5fff 60%, #ff006e 100%)',
        blur: 18,
        opacity: 0.8,
        zIndex: 5,
      },
    ],
  },
  dreamy: {
    backgroundColor: '#f7f1ff',
    shapes: [
      {
        id: 'dreamy-1',
        width: 140,
        height: 55,
        x: -35,
        y: 20,
        gradient: 'radial-gradient(ellipse, rgba(255, 182, 193, 0.7) 0%, rgba(255, 160, 200, 0.5) 40%, rgba(221, 160, 221, 0.3) 100%)',
        blur: 25,
        opacity: 0.9,
        zIndex: 1,
      },
      {
        id: 'dreamy-2',
        width: 125,
        height: 50,
        x: 30,
        y: 45,
        gradient: 'radial-gradient(ellipse, rgba(221, 160, 221, 0.6) 0%, rgba(173, 216, 230, 0.4) 50%, rgba(255, 182, 193, 0.3) 100%)',
        blur: 24,
        opacity: 0.8,
        zIndex: 2,
      },
      {
        id: 'dreamy-3',
        width: 110,
        height: 45,
        x: -20,
        y: 70,
        gradient: 'radial-gradient(ellipse, rgba(173, 216, 230, 0.8) 0%, rgba(255, 182, 193, 0.6) 30%, rgba(221, 160, 221, 0.4) 100%)',
        blur: 23,
        opacity: 0.7,
        zIndex: 3,
      },
      {
        id: 'dreamy-4',
        width: 115,
        height: 40,
        x: 55,
        y: -5,
        gradient: 'radial-gradient(ellipse, rgba(255, 160, 200, 0.5) 0%, rgba(221, 160, 221, 0.4) 60%, rgba(173, 216, 230, 0.3) 100%)',
        blur: 21,
        opacity: 0.6,
        zIndex: 4,
      },
    ],
  },
  neon: {
    backgroundColor: '#0d0d0d',
    shapes: [
      {
        id: 'neon-1',
        width: 135,
        height: 55,
        x: -30,
        y: 25,
        gradient: 'radial-gradient(ellipse, #39ff14 0%, #00ff41 30%, #1dd1a1 70%, #00d4aa 100%)',
        blur: 25,
        opacity: 0.8,
        zIndex: 1,
      },
      {
        id: 'neon-2',
        width: 120,
        height: 50,
        x: 35,
        y: 50,
        gradient: 'radial-gradient(ellipse, #ff073a 0%, #f54291 40%, #bd5eff 80%, #7c3aed 100%)',
        blur: 24,
        opacity: 0.7,
        zIndex: 2,
      },
      {
        id: 'neon-3',
        width: 105,
        height: 45,
        x: -15,
        y: 75,
        gradient: 'radial-gradient(ellipse, #00bcd4 0%, #2196f3 50%, #3f51b5 100%)',
        blur: 23,
        opacity: 0.9,
        zIndex: 3,
      },
      {
        id: 'neon-4',
        width: 125,
        height: 40,
        x: 50,
        y: 5,
        gradient: 'radial-gradient(ellipse, #ffeb3b 0%, #ff9800 40%, #ff5722 80%, #e91e63 100%)',
        blur: 21,
        opacity: 0.6,
        zIndex: 4,
      },
      {
        id: 'neon-5',
        width: 90,
        height: 30,
        x: 25,
        y: 30,
        gradient: 'radial-gradient(ellipse, #9c27b0 0%, #673ab7 50%, #3f51b5 100%)',
        blur: 19,
        opacity: 0.8,
        zIndex: 5,
      },
    ],
  },
}; 